import { SwishPartialStoreState, SWISH_STATE_KEY } from './swish.reducer';

export const getAccountId = ( state: SwishPartialStoreState ) =>
    state[ SWISH_STATE_KEY ].accountId;

export const getTransactionData = ( state: SwishPartialStoreState ) =>
    state[ SWISH_STATE_KEY ].transaction;

export const getError = ( state: SwishPartialStoreState ) =>
    state[ SWISH_STATE_KEY ].error;

export const getTransactionStatus = (state: SwishPartialStoreState) =>
    state[SWISH_STATE_KEY].transactionStatus;